import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Modal } from "antd";
import PurchaseTerms from "./PurchaseTerms";
import AppVersion from "Components/Shared/AppVersion";
import CustomButton from "Components/CustomButton";
import styled from "styled-components";

/** Read colors from ancestor `style={{ "--legal-link-color", "--legal-link-hover" }}` (see LegalAndSupport). */
const LegalLinkSpan = styled.span`
  display: inline-block;
  cursor: pointer;
  text-decoration: underline;
  color: var(--legal-link-color, #1890ff);

  &:hover {
    color: var(--legal-link-hover, #40a9ff);
    text-decoration: none;
  }
`;

const LegalLinkAnchor = styled.a`
  display: inline-block;
  cursor: pointer;
  text-decoration: underline;
  color: var(--legal-link-color, #1890ff);

  &:hover {
    color: var(--legal-link-hover, #40a9ff);
    text-decoration: none;
  }
`;

const LegalAndSupport = ({ data, productData, isMobile = false, customStyle }) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const year = new Date().getFullYear();

  const linkColor = customStyle?.link?.linkColor;
  const hoverLinkColor = customStyle?.link?.hoverLinkColor;

  const legalLinkCssVars = {
    "--legal-link-color": linkColor || "#1890ff",
    "--legal-link-hover": hoverLinkColor || "#40a9ff",
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <div className="legal-container">
        <div className="legal no-radius-top no-border-top" style={legalLinkCssVars}>
          <Trans
            i18nKey="legal.legalText"
            values={{ producerName: data?.producer?.name }}
            components={{
              bold: <strong />,
              termsLink: <LegalLinkSpan onClick={() => showModal()} />,
              policiesLink: <LegalLinkAnchor href="https://ajuda.salespark.io/help/termos-gerais-de-uso-da-salespark" target="_blank" rel="noreferrer" />,
            }}
          />
          <div className="mt-1 mb-1">
            <Trans
              i18nKey="legal.helpText"
              components={{
                helpLink: <LegalLinkAnchor href="https://ajuda.salespark.io/help/comprar-um-produto-pela-salespark" target="_blank" rel="noreferrer" />,
              }}
            />
          </div>
          {data.purchase_id && (
            <div className={`text-muted ${isMobile === true ? "text-center mb-2 mt-2" : "mt-2 d-flex justify-content-between align-items-center"}`}>
              {isMobile === false && <small className="mr-1">© {year} SalesPark </small>}
              <small>
                {t("legal.purchaseId")} <strong>{data.purchase_id}</strong>
              </small>
            </div>
          )}
          {isMobile && (
            <div style={{ textAlign: "center" }}>
              <AppVersion align={"center"} />
            </div>
          )}
        </div>
      </div>
      <Modal
        width={900}
        className="purchase-terms-modal"
        closable
        title={t("legal.modalTitle")}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={
          <CustomButton customStyle={customStyle} type="primary" onClick={() => handleOk()}>
            {t("legal.close")}
          </CustomButton>
        }
      >
        <PurchaseTerms data={data} productData={productData} customStyle={customStyle} />
      </Modal>
    </>
  );
};

export default LegalAndSupport;
